import gql from 'graphql-tag';

export const GetOrganisationByAlias = gql`
  query getOrganisationByAlias($alias: String!) {
    getOrganisationByAlias(alias: $alias) {
        organisationId
        name
        alias
        ssoConfig
        imageUrl
        billingEntityCode
        preferences
        clientType
        orgPackage: package {
          includedAddonTypes
          amendmentsQuantity
          userAllowance
          subEnd
          addonCosts
        }
        organisationProduct {
          organisationProductsId
          organisationId
          trial
          expiryDate
          product {
            productId
            shortName
            longName
          }
        }
    }
  }
`;

const getOrganisationByAlias = () => ({
  query: GetOrganisationByAlias,
  module: 'organisations',
  ignoreCache: true,
  buildVariables: (alias) => ({ alias })
});

export default getOrganisationByAlias;